export default {
  // —— Console/Admin OpenAPI ——
  'pages.openapi.overview.title': 'オープンプラットフォーム概要',
  'pages.openapi.overview.loadFailed':
    '利用状況の概要を読み込めませんでした（API が未準備の可能性があります）',
  'pages.openapi.overview.docsTitle': '連携ガイド',
  'pages.openapi.overview.docsDesc':
    'オープンプラットフォームの BasePath は /v1、応答エンベロープは {code,message,data,request_id} です。API Key 利用時は Authorization ヘッダーに Bearer sk_live_... / sk_test_... を付けてください。鍵の平文は作成またはローテーション時に一度だけ表示されるので、大切に保管してください。',
  'pages.openapi.overview.level': '現在の等級',
  'pages.openapi.overview.qps': 'QPS 上限',
  'pages.openapi.overview.apps': 'アプリ数',
  'pages.openapi.overview.appsSuffix': '（上限 {maxApps}、アプリあたり Key {maxKeys}）',
  'pages.openapi.overview.dailyUsage': '本日の利用量',

  'pages.openapi.status.active': '有効',
  'pages.openapi.status.disabled': '無効',

  'pages.openapi.apps.title': 'アプリとキー',
  'pages.openapi.apps.listTitle': 'マイアプリ',
  'pages.openapi.apps.create': 'アプリを作成',
  'pages.openapi.apps.createModal': 'アプリを作成',
  'pages.openapi.apps.name': 'アプリ名',
  'pages.openapi.apps.nameRequired': '名前を入力してください',
  'pages.openapi.apps.description': '説明',
  'pages.openapi.apps.status': '状態',
  'pages.openapi.apps.createdAt': '作成日時',
  'pages.openapi.apps.createSuccess': 'アプリを作成しました',
  'pages.openapi.apps.createFailed': 'アプリ作成に失敗しました',
  'pages.openapi.apps.loadFailed': 'アプリを読み込めませんでした',
  'pages.openapi.apps.keysLoadFailed': 'キーを読み込めませんでした',
  'pages.openapi.apps.delete': '削除',
  'pages.openapi.apps.deleteConfirm': 'このアプリを削除しますか？',
  'pages.openapi.apps.deleted': '削除しました',
  'pages.openapi.apps.createKey': 'Key を作成',
  'pages.openapi.apps.createKeyModal': 'API Key を作成',
  'pages.openapi.apps.keyCreateSuccess': 'キーを作成しました',
  'pages.openapi.apps.keyCreateFailed': 'キー作成に失敗しました',
  'pages.openapi.apps.noPlainKey': '平文キーが返されませんでした',
  'pages.openapi.apps.plainKeyTitle': 'API Key を安全に保存してください',
  'pages.openapi.apps.plainKeyHint':
    '平文は一度だけ表示され、閉じると再表示できません。',
  'pages.openapi.apps.copy': 'コピー',
  'pages.openapi.apps.copied': 'コピーしました',
  'pages.openapi.apps.copyFailed': 'コピーに失敗しました。手動で選択してください',
  'pages.openapi.apps.close': '閉じる',
  'pages.openapi.apps.key.name': '名前',
  'pages.openapi.apps.key.namePlaceholder': '本番用メイン Key',
  'pages.openapi.apps.key.prefix': '接頭辞',
  'pages.openapi.apps.key.env': '環境',
  'pages.openapi.apps.key.status': '状態',
  'pages.openapi.apps.key.createdAt': '作成日時',
  'pages.openapi.apps.key.disable': '無効化',
  'pages.openapi.apps.key.disableConfirm': 'このキーを無効化しますか？',
  'pages.openapi.apps.key.disabled': '無効化しました',
  'pages.openapi.apps.key.enable': '有効化',
  'pages.openapi.apps.key.enableConfirm': 'このキーを有効化しますか？',
  'pages.openapi.apps.key.enabled': '有効化しました',
  'pages.openapi.apps.key.rotate': 'ローテーション',
  'pages.openapi.apps.key.rotateConfirm':
    'ローテーションでは新しいキーが発行され、平文は一度だけ返されます。続行しますか？',
  'pages.openapi.apps.key.rotated': 'ローテーションしました',
  'pages.openapi.apps.key.delete': '削除',
  'pages.openapi.apps.key.deleteConfirm': 'このキーを削除しますか？元に戻せません。',
  'pages.openapi.apps.key.deleted': '削除しました',

  'pages.openapi.logs.title': '呼び出し履歴',
  'pages.openapi.logs.listTitle': '呼び出し明細',
  'pages.openapi.logs.dailyTitle': '直近 14 日の利用量',
  'pages.openapi.logs.dailyEmpty': '日次利用データがありません',
  'pages.openapi.logs.date': '日付',
  'pages.openapi.logs.count': '呼び出し回数',
  'pages.openapi.logs.createdAt': '時刻',
  'pages.openapi.logs.requestId': 'Request ID',
  'pages.openapi.logs.requestIdPlaceholder': 'API 応答の request_id を貼り付けてください',
  'pages.openapi.logs.detail': '詳細',
  'pages.openapi.logs.detailTitle': '呼び出し詳細',
  'pages.openapi.logs.detailLoading': '読み込み中…',
  'pages.openapi.logs.requestQuery': 'Query',
  'pages.openapi.logs.requestBody': 'リクエスト',
  'pages.openapi.logs.responseBody': 'レスポンス',
  'pages.openapi.logs.app': 'アプリ',
  'pages.openapi.logs.appId': 'アプリ ID',
  'pages.openapi.logs.apiKey': 'API Key',
  'pages.openapi.logs.userId': 'ユーザー ID',
  'pages.openapi.logs.apiKeyId': 'Key ID',
  'pages.openapi.logs.keyPrefix': 'Key 接頭辞',
  'pages.openapi.logs.method': 'メソッド',
  'pages.openapi.logs.path': 'パス',
  'pages.openapi.logs.statusCode': 'HTTP',
  'pages.openapi.logs.code': '業務コード',
  'pages.openapi.logs.latency': '遅延(ms)',
  'pages.openapi.logs.loadFailed': '読み込み失敗',

  'pages.openapi.planTiers.title': 'オープンプラットフォームプラン',
  'pages.openapi.planTiers.level': '等級',
  'pages.openapi.planTiers.levelTip':
    'Plan tier level (1–5), aligned with the user profile Level. Higher numbers mean higher tiers.',
  'pages.openapi.planTiers.name': '名称',
  'pages.openapi.planTiers.qps': 'QPS',
  'pages.openapi.planTiers.qpsTip':
    'Max requests per second (Queries Per Second). Default rate limit for API Key calls on this tier: sustained rate equals this value; burst capacity is about QPS×2 (at least 5). Applies only to API Key calls; console/admin traffic is not counted. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42901).',
  'pages.openapi.planTiers.dailyQuota': '日次クォータ',
  'pages.openapi.planTiers.dailyQuotaTip':
    'Max total API requests allowed per calendar day. Counted per user/key; only API Key calls count. Individual keys may override. Exceeding the limit returns HTTP 429 (biz code 42902).',
  'pages.openapi.planTiers.maxApps': 'アプリ数上限',
  'pages.openapi.planTiers.maxAppsTip':
    'Maximum number of OpenAPI apps a developer on this tier can create.',
  'pages.openapi.planTiers.maxKeys': 'アプリあたり Key 上限',
  'pages.openapi.planTiers.maxKeysTip': 'Maximum number of API keys allowed under each app.',
  'pages.openapi.planTiers.allowedScopes': 'Allowed permissions (scopes)',
  'pages.openapi.planTiers.allowedScopesTip':
    'API permission scopes this tier may request or be granted. App and API Key scopes must be a subset of this selection.',
  'pages.openapi.planTiers.save': '保存',
  'pages.openapi.planTiers.saved': '保存しました',
  'pages.openapi.planTiers.saveFailed': '保存に失敗しました',
  'pages.openapi.planTiers.loadFailed': 'プランを読み込めませんでした',
  'pages.openapi.planTiers.readonly':
    'オブザーバーは読み取り専用で、プラン等級を変更できません',

  'pages.openapi.admin.usageLogsTitle': 'オープンプラットフォーム呼び出し監査',
  'pages.openapi.admin.usageLogsList': '全体呼び出し履歴',
  'pages.openapi.admin.disableKeyConfirm': 'この API Key を無効化しますか？',
  'pages.openapi.admin.disableKey': 'Key を無効化',
  'pages.openapi.admin.keyDisabled': '無効化しました',
  'pages.openapi.admin.appsTitle': 'オープンプラットフォームアプリ管理',
  'pages.openapi.admin.appsList': 'すべての開発者アプリ',
  'pages.openapi.admin.developers': '開発者',
  'pages.openapi.admin.apps': 'アプリ',
  'pages.openapi.admin.keys': 'Key 合計',
  'pages.openapi.admin.activeKeys': '有効な Key',
  'pages.openapi.admin.todayRequests': '本日の呼び出し',
  'pages.openapi.admin.todayErrors': '本日のエラー',
  'pages.openapi.admin.errorCount': 'エラー',
  'pages.openapi.admin.owner': '所有者',
  'pages.openapi.admin.keyCount': 'Key 数',
  'pages.openapi.admin.keyword': 'キーワード',
  'pages.openapi.admin.keywordPlaceholder': 'アプリ名 / 説明 / テナントコード',
  'pages.openapi.admin.statsLoadFailed': '統計の読み込みに失敗しました',
  'pages.openapi.admin.noKeys': 'Key なし',
  'pages.openapi.admin.appEnabled': 'アプリを有効化しました',
  'pages.openapi.admin.appDisabled': 'アプリを無効化しました',
  'pages.openapi.admin.appDisableConfirm': 'このアプリを無効化しますか？',
  'pages.openapi.admin.appEnableConfirm': 'このアプリを有効化しますか？',
  'pages.openapi.admin.keyEnableConfirm': 'このキーを有効化しますか？',

  'pages.admin.user.section.openapi': 'オープンプラットフォーム',
  'pages.admin.user.openapiDeveloperEnabled': 'オープンプラットフォーム',
  'pages.admin.user.openapi.on': '開通済み',
  'pages.admin.user.openapi.off': '未開通',
  'pages.admin.user.openapiLevel': 'オープンプラットフォーム等級',
  'pages.admin.user.openapiDeveloperEnabled.label': '開発者を開通',
  'pages.admin.user.openapiLevel.label': '等級',
  'pages.admin.user.openapiLevel.placeholder': '1-5',
};
